<!--
 * @Description: 
 * @Author: 李方强
 * @Date: 2019-08-15 10:25:21
 * @LastEditTime: 2020-04-07 18:29:40
 * @LastEditors: 李方强
 -->
<template>
  <div>
    <el-dialog
      title="修改地址"
      :modal='false'
      :visible.sync="dialogVisible"
      width="700px"
      :before-close="handleClose"
      @open="handleOpen">
        <el-form ref="form" :model="form" :rules="formRules" label-width="100">
          <el-form-item label="收货地址" required>
            <el-form-item prop="receiverName" style="display: inline-block">
              <el-input v-model="form.receiverName" placeholder="请输入收货人"></el-input>
            </el-form-item>
            <div style="margin-left: 140px;display: inline-block">
              <el-form-item prop="receiverPhone">
                <el-input v-model="form.receiverPhone" maxlength="11" placeholder="请输入电话"></el-input>
              </el-form-item>
            </div>
            <el-form-item required style="margin-bottom: 0">
              <div style="margin-left: 79px;display: inline-block">
                <el-form-item prop="receiverProvince">
                  <el-select v-model="form.receiverProvince" style="width: 120px" placeholder="请选择省" @change="getreceiverProvince">
                    <el-option
                      v-for="item in receiverProvinceList"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <el-form-item prop="receiverCity" style="display: inline-block">
                <el-select v-model="form.receiverCity" style="width: 120px" placeholder="请选择市" @change="getreceiverCity">
                  <el-option
                    v-for="item in receiverCityList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="receiverArea" style="display: inline-block">
                <el-select v-model="form.receiverArea" style="width: 120px" placeholder="请选择区" @change="getreceiverArea">
                  <el-option
                    v-for="item in receiverAreaList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="receiverStreet" style="display: inline-block">
                <el-select v-model="form.receiverStreet" style="width: 120px" placeholder="请选择街道" @change="getReceiverStreet">
                  <el-option
                    v-for="item in receiverStreetList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form-item>
            <div style="margin-left: 79px">
              <el-form-item prop="receiverAddress" style="margin-bottom: 0">
                <div class="innerWidth">
                  <el-input v-model="form.receiverAddress" maxlength="200" placeholder="请输入详细地址"></el-input>
                </div>
              </el-form-item>
            </div>
          </el-form-item>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">取消</el-button>
        <el-button type="primary" @click="submit('form')">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as http from './addAfter.service' // GET POST, DELETE, PUT,

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    userForm: {
      type: Object,
      default() {
        return {
          receiverName: '',
          receiverPhone: '',
          receiverProvince: '',
          receiverCity: '',
          receiverArea: '',
          receiverStreet: '',
          receiverAddress: ''
        }
      }
    }
  },
  data() {
    return {
      receiverProvinceList: [], // 省的列表数据
      receiverCityList: [], // 市的列表数据
      receiverAreaList: [], // 区的列表数据
      receiverStreetList: [], // 街道列表数据
      form: {
        receiverName: '',
        receiverPhone: '',
        receiverProvince: '',
        receiverCity: '',
        receiverArea: '',
        receiverStreet: '',
        receiverAddress: ''
      },
      formRules: {
        receiverProvince: [
          { required: true, message: '请选择省', trigger: 'blur' }
        ],
        receiverCity: [
          { required: true, message: '请选择市', trigger: 'blur' }
        ],
        receiverArea: [
          { required: true, message: '请选择区', trigger: 'blur' }
        ],
        receiverName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        receiverPhone: [
          { 
            required: true,
            validator: (rule, value, callback) => {
              this.checkreceiverPhone(rule, value, callback)
            },
            trigger: 'blur'
          }
        ],
        receiverAddress: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ]
      },
      objForm: {
        receiverName: '',
        receiverPhone: '',
        receiverProvince: '',
        receiverCity: '',
        receiverArea: '',
        receiverStreet: '',
        receiverAddress: ''
      }
    }
  },
  methods: {
    /**
     * 打开弹窗事件
     */
    handleOpen() {
      this.form.receiverName = this.userForm.receiverName
      this.form.receiverPhone = this.userForm.receiverPhone
      this.form.receiverAddress = this.userForm.receiverAddress
      // 初始化省市区
      this.getAddress(0, '0')
    },
    /**
     * 关闭弹窗事件
     */
    handleClose() {
      this.form.receiverProvince = ''
      this.form.receiverCity = ''
      this.form.receiverArea = ''
      this.form.receiverStreet = ''
      this.$emit('closeBtn')
    },
    /**
     * 手机正则校验
     */
    checkreceiverPhone(rule, value, callback) {
      const reg = /^1[3-9]\d{9}$/
      if (value === '') {
        callback(new Error('请输入手机号码'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    },
    /**
     * 省市区级联函数
     * type - 当前点击的类型 0-初始值 1-省 2-市 3-区
     * code - 省市区传递的id值
     */
    getAddress(type, code) {
      http.getAddress({ parentCode: code }).subscribe(
        (res) => {
          if (res.response.data.errorCode === 0) {
            switch (type) {
              case 0:
                this.receiverProvinceList = res.response.data.data
                break
              case 1:
                this.receiverCityList = res.response.data.data
                break
              case 2:
                this.receiverAreaList = res.response.data.data
                break
              case 3:
                this.receiverStreetList = res.response.data.data
                break
              default:
                break
            }
          }
        }
      )
    },
    /**
     *选择省点击事件
     */
    getreceiverProvince(val) {
      this.receiverProvinceList.map((item) => {
        if (item.code === val) {
          this.objForm.receiverProvince = item.name
        }
        return this.objForm.receiverProvince
      })
      this.getAddress(1, val)
      this.form.receiverCity = ''
      this.form.receiverArea = ''
      this.form.receiverStreet = ''
      this.receiverAreaList = []
      this.receiverStreetList = []
    },
    /**
     * 选择市点击事件
     */
    getreceiverCity(val) {
      this.receiverCityList.map((item) => {
        if (item.code === val) {
          this.objForm.receiverCity = item.name
        }
        return this.objForm.receiverCity
      })
      this.getAddress(2, val)
      this.form.receiverArea = ''
      this.form.receiverStreet = ''
      this.receiverStreetList = []
    },
    /**
     *选择区点击事件
     */
    getreceiverArea(val) {
      this.receiverAreaList.map((item) => {
        if (item.code === val) {
          this.objForm.receiverArea = item.name
        }
        return this.objForm.receiverArea
      })
      this.getAddress(3, val)
      this.form.receiverStreet = ''
    },
    // 选择街道点击事件
    getReceiverStreet(val) {
      this.receiverStreetList.map((item) => {
        if (item.code === val) {
          this.objForm.receiverStreet = item.name
        }
        return this.objForm.receiverStreet
      })
    },
    /**
   * 提交
   */  
    submit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.objForm.receiverName = this.form.receiverName
          this.objForm.receiverPhone = this.form.receiverPhone
          this.objForm.receiverAddress = this.form.receiverAddress
          this.$emit('submitBtn', this.objForm)
        }
      })
    }
  }
}
</script>
<style lang="less">
  .innerWidth{
    width: 480px;
  }
</style>
